module.exports = __webpack_public_path__ + "img/darna.74781fc0.jpg";